import {Button, Modal, Spinner} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Dropdown from "../../../../primer/Dropdown";
import axios from "axios";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import {outcomeOptions, outComeOptionsNoPartial} from "./constants";
import BetterCheckBox from "../../../../common/BetterCheckBox";
import PackingsDeclarations from "../../../../primer/POPUP-COMPONENTS/PackingsDeclarations/PackingsDeclarations";

const DeliveryOutcomeModal = ({show, setShow, qrUrls, defaultPD, successCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const initRequestData = {
        outcome: "FULL",
        deliveredWithoutRecipient: false,
        packingsDeclarations: [],
    }
    const [requestData, setRequestData] = useState({...initRequestData});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!show) {
            setRequestData({...initRequestData});
        } else {
            if (defaultPD) {
                setRequestData({...requestData, packingsDeclarations: defaultPD});
            }
        }
    }, [show]);

    const onAccept = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/confirm-delivery-outcome`, {
            ...requestData,
            qrUrls,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.errors) {
                    for (const err of res.data.errors) {
                        toast.error(err);
                    }
                }
                const successCount = qrUrls.length - res.data.errors.length;
                if (successCount > 0) toast.success(`Επιτυχής καταχώρηση ${successCount} Δ.Α.`);
                setShow(false);
                if (successCallback) successCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const getOutcomeOptions = () => {
        if (qrUrls.length === 1) return outcomeOptions;
        else return outComeOptionsNoPartial;
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Ολοκλήρωση Διακίνησης</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Dropdown
                    name={"outcome"}
                    label={"Κατάσταση"}
                    options={getOutcomeOptions()}
                    defaultValue={getOutcomeOptions().find((el) => el.value === requestData.outcome)}
                    key={Math.random()}
                    onChange={(e) => setRequestData({...requestData, outcome: e.value})}
                />
                <BetterCheckBox
                    name={"deliveredWithoutRecipient"}
                    text={"Η παράδοση έγινε χωρίς την παρουσία του παραλήπτη"}
                    className={"mb-2"}
                    checked={requestData.deliveredWithoutRecipient}
                    onChange={(e) => setRequestData({...requestData, deliveredWithoutRecipient: e.target.checked})}
                />
                {requestData.outcome === "PARTIAL" && (
                    <React.Fragment>
                        <hr className={"mb-2 mt-3"} />
                        <div className={"mb-2"}>Παρακαλώ συμπληρώστε τις συσκευασίες που παραλάβατε</div>
                        <PackingsDeclarations
                            packingsDeclarations={requestData.packingsDeclarations}
                            callbackFunction={(arr) => {
                                setRequestData({...requestData, packingsDeclarations: arr});
                            }}
                            viewMode={false}
                            mdWidth={6}
                        />
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                    Κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => onAccept()} disabled={loading}>
                    Καταχώρηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeliveryOutcomeModal;
